module.exports = __webpack_public_path__ + "static/img/1.9561fd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/1.png
// module id = 7e3m
// module chunks = 0